import _ from 'lodash'

const extButtonList = function(extBtns) {
  const taskbtns = withTask('extButton.', this.taskFormPropertyList)
  const btns = _.filter(extBtns, (o) => {
    const {
      onClick,
      prop
    } = o
    return onClick === 'submit' && prop !== 'sign'
  })

  const btns2 = _.filter(btns, (item) => {
    const {
      prop
    } = item
    const isHide = _.filter(taskbtns, { id: `extButton.${prop}` })
    return !isHide.length
  })

  this.extBtns = btns2
}

const withTask = (prefix, taskFormPropertyList) => {
  return _.filter(taskFormPropertyList, (o) => {
    const {
      id,
      value
    } = o
    return id.includes(prefix) && value === 'false'
  })
}

export default {
  data() {
    return {
      taskFormPropertyList: [],
      extButtonList: []
    }
  },
  mounted() {

  },
  methods: {
    initBtns(taskFormPropertyList, extButtonList) {
      this.taskFormPropertyList = taskFormPropertyList
      this.extButtonList = extButtonList
    }
  }
}

export {
  extButtonList
}
